import { createHttpClient } from '@akyga/shared-ui/httpClient';
import config from 'config/config';

const cmsClient = createHttpClient(config.CMS_BASE_URL);

export default cmsClient;
